import type { FC } from "react";
import { StarRating } from "../StarRating";
import { RegionalReviewCountryFlag } from "./RegionalReviewCountryFlag";
import type { RegionalReviewCardContentProps } from "./types";

export const RegionalReviewCardMobileContent: FC<
  RegionalReviewCardContentProps
> = ({
  countryCode,
  displayName,
  formattedRating,
  formattedReviewCount,
  rating,
}) => (
  <div className="d-flex d-md-none flex-column w-100 p-3">
    <div className="d-flex align-items-center mb-1">
      <RegionalReviewCountryFlag countryCode={countryCode} />
      <h3
        className="heading strong mb-0 ml-3 reviews_regional_card_mobile_name"
        style={{ textTransform: "none" }}
      >
        {displayName}
      </h3>
    </div>
    <div className="d-flex align-items-center justify-content-between flex-nowrap w-100 reviews_regional_card_mobile_rating_section">
      <span className="font-weight-bold reviews_regional_card_mobile_rating">
        {formattedRating}
      </span>
      <StarRating
        rating={rating}
        size="xl"
        className="reviews_regional_card_mobile_stars"
      />
      <span className="text-gray reviews_regional_card_mobile_count">
        {formattedReviewCount}
      </span>
    </div>
  </div>
);
